import { render, staticRenderFns } from "./CarNumberReportScreen.vue?vue&type=template&id=4faee534"
import script from "./CarNumberReportScreen.vue?vue&type=script&lang=js"
export * from "./CarNumberReportScreen.vue?vue&type=script&lang=js"
import style0 from "./CarNumberReportScreen.vue?vue&type=style&index=0&id=4faee534&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports